export default __webpack_public_path__ + "static/media/buenas_tardes.f5265604.png";